import { uuid } from "../../../../common/src";
import { WorkbenchTabGroup, WorkbenchViewport } from "../../workbench/state";

import { ContextWorkbenchEditorFiles } from "./contextWorkbenchEditorFiles";
import { ContextWorkbenchEditorRegions } from "./contextWorkbenchEditorRegion";
import { ContextWorkbenchEditorSidebar } from "./contextWorkbenchEditorSidebar";
import { ContextWorkbenchEditorTab } from "./contextWorkbenchEditorTab";
import {
  ContextWorkbenchFile,
  ContextWorkbenchFileId,
} from "./contextWorkbenchFile";

export type ContextWorkbenchState = {
  view: "editor"; // TODO(CUR-980): add 'publish'
  editor: {
    tabGroups: WorkbenchTabGroup<ContextWorkbenchEditorTab>[];
    viewport: WorkbenchViewport;
    regions: ContextWorkbenchEditorRegions;
    sidebar: ContextWorkbenchEditorSidebar;
    files: ContextWorkbenchEditorFiles;
  };
};

// implemented as a function to protect against changes
export const getContextWorkbenchInitialState = (): ContextWorkbenchState => {
  return {
    view: "editor",
    editor: {
      tabGroups: [],
      viewport: { type: "empty" },
      regions: {
        left: {
          position: "left",
          display: "sidebar",
          isOpen: true,
          size: 341,
          maxSize: 600,
          minSize: 200,
        },
        bottom: {
          position: "bottom",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
        right: {
          position: "right",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
      },
      sidebar: {
        panelId: "files",
        files: {
          type: "files",
        },
      },
      files: {
        magicRules: {
          id: ContextWorkbenchFileId.check(uuid()),
          type: ContextWorkbenchFile.Type.Rule,
          data: undefined,
          loading: false,
          error: undefined,
        },
      },
    },
  };
};
